/** Per-plane damage trails advance once per generated game frame. */
import type { Plane } from '../sim/sim.js';
import { FxRandom } from './particles.js';
export const SMOKE_SLOTS = 6;
export const SMOKE_FRAME_FIRST = 9;
export const SMOKE_FRAME_LAST = 13;
export const SMOKE_ROLL = 12;
export const DAMAGE_FLICKER_FIRST = 14;
export const DAMAGE_FLICKER_FRAMES = 3;
interface TrailSlots {
  aw: number[];
  ax: number[];
  ay: number[];
}
function drawCentered(
  ctx: CanvasRenderingContext2D,
  img: HTMLImageElement,
  wx: number,
  wy: number,
  camX: number,
  camY: number,
): void {
  const sx = wx - camX;
  const sy = wy - camY;
  if (sx < -20 || sy < -20 || sx > 148 || sy > 148) return;
  ctx.drawImage(img, wx - (img.width >> 1), wy - (img.height >> 1));
}
export class SmokeTrail {
  private readonly slots: [TrailSlots, TrailSlots];
  private readonly q: [number, number] = [0, 0];
  constructor() {
    const mk = (): TrailSlots => ({
      aw: new Array<number>(SMOKE_SLOTS).fill(-1),
      ax: new Array<number>(SMOKE_SLOTS).fill(0),
      ay: new Array<number>(SMOKE_SLOTS).fill(0),
    });
    this.slots = [mk(), mk()];
  }
  reset(): void {
    for (const s of this.slots) {
      s.aw.fill(-1);
      s.ax.fill(0);
      s.ay.fill(0);
    }
    this.q[0] = 0;
    this.q[1] = 0;
  }
  resetSide(side: 0 | 1): void {
    this.slots[side].aw.fill(-1);
  }
  stepAndDraw(
    ctx: CanvasRenderingContext2D,
    p: Plane,
    camX: number,
    camY: number,
    get: (name: string) => HTMLImageElement | undefined,
    rng: FxRandom,
  ): void {
    const s = this.slots[p.side]!;
    if (p.a >= 2) return;
    if (p.hitP <= 0) return;
    if (p.hitP === 2) {
      const img = get(`fx_${String(DAMAGE_FLICKER_FIRST + this.q[p.side]!).padStart(2, '0')}`);
      if (img) drawCentered(ctx, img, p.x >> 6, p.y >> 6, camX, camY);
      this.q[p.side] = this.q[p.side]! + 1;
      if (this.q[p.side]! > DAMAGE_FLICKER_FRAMES - 1) this.q[p.side] = 0;
    }
    for (let i = SMOKE_SLOTS - 1; i >= 0; i--) {
      if (s.aw[i] === -1) {
        if (rng.below(SMOKE_ROLL) < p.hitP * 2) {
          s.aw[i] = p.x >> 6;
          s.ax[i] = p.y >> 6;
          s.ay[i] = 0;
          return;
        }
      } else {
        const frame = s.ay[i]!;
        const img = get(`fx_${String(SMOKE_FRAME_FIRST + frame).padStart(2, '0')}`);
        if (img) drawCentered(ctx, img, s.aw[i]!, s.ax[i]!, camX, camY);
        s.ay[i] = frame + 1;
        if (s.ay[i]! > SMOKE_FRAME_LAST - SMOKE_FRAME_FIRST) s.aw[i] = -1;
      }
    }
  }
}
